<app-si-dialog modalBodyClasses="flex flex-col h-full w-full overflow-hidden p-4 min-h-[200px]" header="Export to Marketo">
	<ng-template appDialogBody>
		<ng-container *ngIf="accuracyTier">
			<div class="mb-4 text-center rounded-md border border-warning bg-warning-container text-dark px-4 py-3 text-sm">{{accuracyTierText}}</div>
		</ng-container>

		<div class="flex flex-col overflow-hidden">
			<div *ngIf="isBusy" class="mt-12">
				<div class="flex flex-wrap -mx-2">
					<div class="w-full sm:flex-none sm:w-1/12 px-2">
					</div>
					<div class="w-full sm:flex-none sm:w-5/6 text-center px-2">
						<b>{{busyLabel}}</b><br />
						{{busySublabel}}
					</div>
					<div class="w-full sm:flex-none sm:w-1/12 px-2">
					</div>
				</div>
			</div>
			<ng-container *ngIf="currentPage === pages.leadPartition && !isBusy">
				<h3>Lead Partition (optional)</h3>
				Select the lead partition in which new leads should be added. Any duplicates will be updated in the partition
				they exist in.
				<div class="flex-none w-full px-0 pt-2">
					<mat-form-field appearance="outline" class="mb-1 w-full no-padding">
						<mat-label>Filter by name</mat-label>
						<input matInput type="text" placeholder="Filter by name" [(ngModel)]="filterLeadPartition">
						<fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
					</mat-form-field>
				</div>
				<div class="table-scroll">
					<table class="table-fixed si-table si-table--striped si-table--hover si-table--grid">
						<thead>
						<tr class="flex flex-wrap -mx-2 row-width">
							<th class="flex-none w-1/4 px-2">
								Name
							</th>
							<th class="flex-none w-2/3 px-2">
								Description
							</th>
							<th class="flex-none w-1/12 px-2" *ngIf="(leadPartition | filter: filterLeadPartition).length > 0">
								&nbsp;
							</th>
						</tr>
						</thead>
						<tbody>
						<tr class="flex flex-wrap -mx-2 row-width" (click)="selectLeadPartition(leadPartition.name)"
							*ngFor="let leadPartition of leadPartition | filter: filterLeadPartition | orderBy : 'name'">
							<td class="flex-none w-1/4 px-2">{{ leadPartition.name }}</td>
							<td class="flex-none w-2/3 px-2">{{ leadPartition.description }}</td>
							<td class="flex-none w-1/12 text-center px-0">
								<fa-icon [hidden]="leadPartition.name !== partitionName" class="py-0" [icon]="['fas', 'check']"></fa-icon>
							</td>
						</tr>
						<tr *ngIf="(leadPartition | filter: filterLeadPartition).length === 0">
							<td colspan="2" class="flex-none w-full text-center bg-white py-6 px-2">
								<i>No Lead Partition Found</i></td>
						</tr>
						</tbody>
					</table>
				</div>
			</ng-container>
			<ng-container *ngIf="currentPage == pages.duplicates && !isBusy && duplicateCount>0">
				<h3>Duplicates</h3>
				<div class="flex flex-wrap -mx-2">
					<div class="w-full md:flex-none md:w-1/2 px-2">
						<b>Found {{duplicateCount}} duplicate<span *ngIf="duplicateCount != 1">s</span>:</b>
					</div>
					<div class="w-full md:flex-none md:w-1/2 px-2">
						<b>Resolve Duplicates by:</b>
					</div>
				</div>
				<div class="flex flex-wrap -mx-2">
					<div class="w-full md:flex-none md:w-1/2 pl-4 pb-2 table-scroll">
						<table class="table-fixed border si-table si-table--hover">
							<tbody>
							<tr *ngFor="let match of duplicateMatchIds">
								<td class="flex-none w-full px-2">{{match.contactName}}</td>
							</tr>
							</tbody>
						</table>
					</div>
					<div class="flex-none w-1/2 px-2">
						<app-duplicate-resolution-radio-group [(ngModel)]="duplicateResolution"></app-duplicate-resolution-radio-group>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="currentPage == pages.exportFinished && isBusy == false">
				<div class="pl-6 pr-6 pt-2 export-succes">
					<div class="flex flex-wrap -mx-2">
						<div class="w-full md:flex-none md:w-1/12 px-2">
						</div>
						<div class="w-full md:flex-none md:w-5/6 text-center px-2">
							<h3>Export Succeeded</h3>
							You have successfully exported {{exportedContactCount}} contact<span
								*ngIf="exportedContactCount != 1">s</span> to Marketo.
							<br /><br />
							<span>
                        Exported contacts to Marketo may take a long time to display. It is recommended that you can
                        check them after sometime.
                    </span>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="currentPage == pages.exportEmpty && !isBusy">
				<div class="text-center pt-4 pb-4">
					<h3>Nothing to Export</h3>
					All selected contacts are duplicates and you decided to skip duplicates, so there's nothing left to export.
				</div>
			</ng-container>
			<ng-container *ngIf="currentPage == pages.exportFailed && !isBusy">
				<h3>Export Failed</h3>
				Your export failed with the following error: <br /><br />
				<pre class="text-danger" style="max-height: 200px; white-space: pre-wrap;">{{exportError}}</pre>
				<br />
				Please resolve the problem in your HubSpot instance and retry or contact SalesIntel support at <a
					href="mailto:support@salesintelio">support&#64;salesintel.io</a>.
			</ng-container>
		</div>
	</ng-template>

	<ng-template appDialogFooter>
		<div>
			<button matButton="outlined" type="button" *ngIf="showCancelButton" (click)="close()">Cancel</button>
		</div>
		<div>
			<button matButton="outlined" type="button" class="mr-2" *ngIf="showPreviousButton"
					(click)="previous()">Previous</button>
			<button matButton="filled" type="button" class="ml-2" (click)="next()" *ngIf="showNextButton">Next</button>
			<button matButton="outlined" class="ml-2" *ngIf="showCloseButton" (click)="close()">Close</button>
		</div>
	</ng-template>
</app-si-dialog>
